import { connectedStore } from '../../store';
import getLimits from '../../integration/selectors/limits';
import constants from '../constants/common';

const limitedBlocks = {
  onlineStore: constants.ONLINE_STORE_BLOCK_ID,
};

const isBlockDisabled = (block) => {
  if (block.disabled) return true;

  const store = connectedStore.get();
  const state = store.getState();
  const limits = getLimits(state);

  const limitsToCheck = Object.keys(limitedBlocks);

  const appliedLimit = limitsToCheck.find((limit) => block.id === limitedBlocks[limit]);

  return appliedLimit && limits[appliedLimit] ? !limits[appliedLimit].available : false;
};

export default isBlockDisabled;
